<template>
    <div class="short-atc-main">
        <div class="notification is-black">
            <p><strong>Short ATC Flight Plan - Fligt Info : {{EFF_Json_Data.poZipMain.Carrier + EFF_Json_Data.poZipMain.fNo+"-"+EFF_Json_Data.poZipMain.Dep +"-"+EFF_Json_Data.poZipMain.Arr+" "+" STD "+":"+flight.std}}</strong></p>
        </div>


        <div class="notification">
            <div class="atc-route notification is-black">

                <pre style="background-color: black;color: white;font-size: large">{{EFF_Json_Data.poOFP.AtcShortText}}</pre>

            </div>
        </div>

    </div>
</template>

<script>
    import {mapState, mapActions /*,mapGetters*/} from "vuex";
    import {loadingMixin} from "../../../../utils/mixins";
    export default {
        name: "shortatc",
        mixins: [loadingMixin],
        props: ["id", "flight"],
        data() {
            return {
                filteredOfpTextList : [],
                flightInfo : "",
            }
        },
        computed : {
            ...mapState("ipadmain",[/*"FKey1",*/ "selectedFlightItems","EFF_Json_Data","WR_Json_Data"]),
            // ...mapState("shortatc",["jsonDataOfpTxt","samplevalue","jsonDataOfpFlight"]),
            // ...mapGetters("shortatc",["ParseAtcShortDataFromOfpTextData"]),
        },
        async created() {

           // await this.GetJsonDataR("OFPTXT");
           // await this.GetJsonDataR("OFPFLIGHT");
           // this.GetShortAtcTitle();

        },
        methods : {
            ...mapActions("shortatc", ["getJsonDataOfpText"]),

                // silinecek...
               // async GetJsonDataR(TableVal)
               //  {
               //      try {
               //          const valcode = TableVal;
               //          await this.getJsonDataOfpText({FKey1: this.flight.fKey1, TableCode: valcode});
               //      }
               //      catch(e)
               //      {
               //          this.$notify({title: "Error", text: e.message, type: "error"});
               //      }
               //
               //  },

            // silinecek
            // GetShortAtcTitle(){
            //   this.flightInfo = this.jsonDataOfpFlight[0].ATCCallsign+ " - " + this.jsonDataOfpFlight[0].DepartureAirportIcao+ " - " + this.jsonDataOfpFlight[0].ArrivalAirportIcao +"-" + " STD "+"-" + this.flight.std;
            // },

        }
    }




</script>

<style scoped>

</style>
